import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7roido2aep: FaireBrandEntity = {
  token: "b_7roido2aep",
  type: "brand",
  name: "Max Green Alchemy",
  avatarUrl:
    "https://cdn.faire.com/fastly/81e0e3087b32830a7b9cd0757d199924e1082a42e50e2408a7af87434ca2e6ed.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a198560d8ee9f5831c98bee458427e46b0fd5d2abb30751e3734552fafb755a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/81e0e3087b32830a7b9cd0757d199924e1082a42e50e2408a7af87434ca2e6ed.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a198560d8ee9f5831c98bee458427e46b0fd5d2abb30751e3734552fafb755a.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "Founders David and Wil's eureka moment came in 2004. The 'green' European personal care market, where they worked, was growing at an unprecedented rate due to consumer demand for ethical and clean personal care products. The American market had barely registered this important trend and the companies within it were often misleading and greenwashing to be more attractive to consumers. Some companies weren't even natural at all - their ingredients told a different story. Even worse, consumers were led to believe that there had to be a trade off - choosing an environmentally clean product meant it was not going to be that effective at all.\n\nDavid and Wil knew that their knowledge and appreciation of natural ingredients, and their established experience with formulating, could produce highly effective, natural and sensual solutions that really worked for the hair, body and skin. This was the spark that became Max Green Alchemy.\n\nMany recently-launched companies claim that they revolutionized the personal care market with their choice of ingredients. Almost two decades ago Max Green Alchemy actually did.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:51.482Z",
    importedBy: "entity-db-cli",
  },
};
